export default "__VITE_ASSET__dc4f5757__"